<template>
  <div class="container">
    <div class="hex-page" id="box" ref="hexBox">
      <ul class="grid-1 hex-grid">
        <li v-for="(el, index) in hexData" :key="el._id" ref="hexData" class="hex-container" :style="hexGridLayoutStyle(index)" >
          <div class="hexContainerOutside">
            <div class="hexContainerInside" @click="clickHandler(el)" :style="hexColorStyle(el)" >
              <label class="hex-title"    :style="(hexSize<=32) ? 'visibility:hidden;' : ''" >{{ el.title }}</label>
              <label class="hex-subtitle" :style="(hexSize<=32) ? 'visibility:hidden;' : ''">{{el.status1}} {{el.status2}}</label>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
let offset = 0;

export default {
  name: "Hexagon-Component",
  props: {
    hexSize: { type: Number, default: 32 },
    hexData: { type: Array, default: () => [] },
    enableClickHandler: { type: Boolean, default: false },
    enableClickSelect: { type: Boolean, default: false },
    colorCodes: {
      type: Array,
      default: () => [
        "#60cacb",
        "#85b37f",
        "#aeb27f",
        "#efc469",
        "#ce7a6e",
        "#eb7c4b",
        "#ed5d4e",
        "#4eeb63",
        "#ed69ff",
        "#292525"
      ]
    }
  },
  computed: {},
  data() {
    return {
      boxWidth: 0,
      boxHeight: 0
    };
  },
  mounted() {
    window.addEventListener("resize", this.getBoxSize); // watch for change
    this.getBoxSize(); // and fire the first time
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getBoxSize);
  },
  methods: {
    clickHandler( el ) {
      if( this.enableClickHandler ) {
        this.$emit( "click" , el );
      }

      if( this.enableClickSelect ) {
        if( el.selected ) {
          el.selected = false;
        } else {
          el.selected = true;
        }
      }
    },
    hexColorStyle( el ) {
      let s = "font-size:" + (this.hexSize/4.4).toString() + "px;";
      if( el.selected ) {
        return s + "background:" + this.colorCodes[this.colorCodes.length-1] + ";";
      }
      return s + "background:" + this.colorCodes[el.status] + ";";
    },
    hexGridLayoutStyle(index) {
      let w = Math.floor(this.boxWidth / this.hexSize);
      // let h=this.hexSize<=128 ? 2 : Math.floor(this.hexSize * 0.066)-2.250;
      let h=2.15;
      let style = "width:" + (this.hexSize-h).toString() + "px;";
      if (w % 2) { // Odd # elements on top row
        this.offset = (this.boxWidth % this.hexSize) - this.hexSize / 2 + 1 < 0 ? 1 : 0;
        if (index % (w * 2 - this.offset) === 0) {
          let m = Math.floor(this.hexSize / 2).toString() + "px;";
          style += "margin-left:" + m + ";";
        }
      } else { // even row
        this.offset = (this.boxWidth % this.hexSize) - this.hexSize / 2 < 0 ? 2 : 0;
        if (index % (w * 2 - this.offset) === 0) {
          let m = Math.floor(this.hexSize / 2).toString() + "px;";
          style += "margin-left:" + m;
        }
      }
      return style; // returns just hexSize unless we're starting a new row
    },
    getBoxSize(event) {
      // NOTE: This is the BOX size, not window size
      let t = this;
      t.boxWidth = t.$refs.hexBox.clientWidth;
      t.boxHeight = t.$refs.hexBox.clientHeight;
    }
  }
};
</script>

<style lang="scss">

@keyframes move {
  100% { 
    motion-offset: 100%;   /* Old */
    offset-distance: 100%; /* New */
  }
}
@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

.hex-grid {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  font-family:Arial, Helvetica, sans-serif;
  font-size: 0.8vw;
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.hex-grid label {
  color: white;
}
.hex-page {
  margin: 5% 0 5% 0;
  max-width: 98vw;
}
.hex-container {
  position: relative;
  /* visibility: hidden; */
  outline: 1px solid transparent;
  margin: 1px;

  transition: 0.5s background-color;
}
/* .hex {
  transition: 0.5s;
} */

.hex-container:hover {
  transition: .35s ease-in-out;
  transition-delay:.85s;
  transform: rotate(-4deg) scale(3) ;
  z-index: 9999;
}

.hex-hide {
  visibility:hidden;
}

.hex-container:hover label {
  visibility:visible !important;
  display:show
}

.hex-container::after {
  content: "";
  display: block;
  padding-bottom: 86.602%;
}

.hexContainerOutside {
  position: absolute;
  width: 96%;
  padding-bottom: 110.851%;
  margin: 0 2%;
  overflow: hidden;
  /* visibility: hidden; */
  outline: 1px solid transparent;
  -webkit-transform: rotate3d(0, 0, 1, -60deg) skewY(30deg);
  -ms-transform: rotate3d(0, 0, 1, -60deg) skewY(30deg);
  transform: rotate3d(0, 0, 1, -60deg) skewY(30deg);
}
.hexContainerOutside * {
  position: absolute;
  /* visibility: visible; */
  outline: 1px solid transparent;
}

.hexContainerInside {
  display: block;
  width: 100%;
  height: 100%;
  color: #fff;
  overflow: hidden;
  -webkit-transform: skewY(-30deg) rotate3d(0, 0, 1, 60deg);
  -ms-transform: skewY(-30deg) rotate3d(0, 0, 1, 60deg);
  transform: skewY(-30deg) rotate3d(0, 0, 1, 60deg);
  background-color: #000;
  text-decoration: none;
}

.hex-title {
  /* padding: 7px 0px; */
  position: relative;
  margin-top:1em;
  margin-bottom:0;
  padding-bottom:0;
  font-size:90%;
  width: 100%;
  text-align: center;

  /* top: 50%; */
  /* left: 50%; */
  /* transform: translate(-50%, -50%); */
}

.hex-subtitle {
  position:relative;
  padding: 0;
  top:-.5em;
  font-size:75%;
  width:100%;
  text-align:center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* left: 50%; */
  /* transform: translate(-50%, -50%); */
}


/* .hexContainerOutside .big-title{
  font-size: 2vh;
  display: block;
}
.hexContainerOutside .big-subtitle{
  font-size: 1vh;
  margin:0;
  display: block;
} */

/* .hexContaineOutside:hover {
  transition-delay:.5s;
  background:green !important;
  text-decoration: none;
} */

</style>
